import { a as e, g as t, i as n, o as r, r as i, t as a } from "./dist-CQa_ahbE.js";
//#region src/utils/UnauthorizedError.ts
var o = class extends Error {
	constructor(e) {
		super(e), this.name = "UnauthorizedError";
	}
}, s = class extends Error {
	body;
	constructor(e) {
		super("Validation error"), this.name = "ValidationError", this.body = e;
	}
}, c = (e) => {
	if (typeof e == "object" && e && "status" in e && typeof e.status == "number") {
		if (e.status === a.BadRequest && "body" in e) return new s(e.body);
		if (e.status === a.Unauthorized) return new o("Unauthorized");
	}
	return e;
};
//#endregion
//#region src/composables/useDelegationService.ts
t.interceptors.error.use((e, t) => {
	if (t && typeof t == "object" && "status" in t) {
		let n = t.status;
		return e && typeof e == "object" ? {
			...e,
			status: n
		} : { status: n };
	}
	return e;
});
var l = () => t.getConfig().auth, u = (e = { token: void 0 }) => {
	if (!e.token) throw Error("Token is required");
	let r = {
		baseUrl: n,
		auth: e.token
	};
	return e.environment && e.environment === "acceptance" && (r.baseUrl = i), e.locale && (r.headers = {
		...r.headers,
		"Accept-Language": e.locale
	}), t.setConfig(r), e.token;
}, d = (e) => {
	t.setConfig({ headers: {
		...t.getConfig().headers,
		"Accept-Language": e
	} });
}, f = async (t) => {
	try {
		return (await e({ body: t })).data;
	} catch (e) {
		throw c(e);
	}
}, p = async (e) => {
	try {
		return (await r({ body: e })).data;
	} catch (e) {
		throw c(e);
	}
};
function m() {
	return {
		createDelegationRequestsApiKey: f,
		createDelegationRequestsApiKeyWithoutSecret: p,
		getToken: l,
		initClient: u,
		setAcceptLanguageHeader: d
	};
}
//#endregion
export { m as t };
